let transaction_routes = [
  {
    path: '/',
    component: () => import('Modules/Dashboard/resources/layout/DashboardLayout.vue'),
    children: [
      { path: 'transactions/incoming', name: 'transactions.incoming', component: () => import('./pages/Incoming.vue') },
      { path: 'transactions/outgoing', name: 'transactions.outgoing', component: () => import('./pages/Outgoing.vue') },
      { path: 'transactions', name: 'transactions.list', component: () => import('./pages/History.vue') },
    ]
  }
];

export default transaction_routes;
